import { Theme } from '@mui/material';

const styleOverrideRadio = (theme: Theme) => ({
  '&.MuiRadio-colorPrimary': {
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  '&.MuiRadio-colorSecondary': {
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
    },
  },
  '&.MuiRadio-colorError': {
    '&.Mui-checked': {
      color: theme.palette.error.main,
    },
  },
  '&.MuiRadio-colorWarning': {
    '&.Mui-checked': {
      color: theme.palette.warning.main,
    },
  },
  '&.MuiRadio-colorInfo': {
    '&.Mui-checked': {
      color: theme.palette.info.main,
    },
  },
  '&.MuiRadio-colorSuccess': {
    '&.Mui-checked': {
      color: theme.palette.success.main,
    },
  },
  '&.MuiRadio-colorDefault': {
    '&.Mui-checked': {
      color: theme.palette.text.secondary,
    },
  },
});

export default styleOverrideRadio;
